<template>
  <div class="product" v-if="!isNaN(product.price)">
    <img
      :src="product.photos && product.photos[0] ? product.photos[0].url : 'https://via.placeholder.com/200x200'"
      class="product__photo"
    />
    <p class="product__name">{{ product.name }}</p>

    <div class="product__price">
      <div class="pricesProduct">
        Prix: {{ product.price | money }}
      </div>
    </div>

    <div class="product__buttons">
      <router-link
        tag="button"
        :to="{ name: 'ProductPage', params: { id: product.id } }"
        class="btn btn-secondary"
      >
        Voir ce produit
      </router-link>
      <button
        @click="addProductToCart({ productId: product.id, quantity: '+' })"
        class="btn btn-primary"
      >
        Ajouter au panier
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  export default {
    name: 'product',
    props: {
      product: Object
    },
    computed: {
      ...mapState({
        connected: state => state.account.status.loggedIn
      })
    },
    methods: {
      ...mapActions('orders', {
        addProductToCart: 'upsertProduct'
      })
    }
  };
</script>

<style lang="scss" scoped>
.product {
  border: 1px solid rgba(0, 0, 0, 0.31);
  display: flex;
  flex-direction: column;
  flex: 0 49%;

  &__photo {
    width: 100%;
    max-width: 200px;
    margin: 10px auto 20px auto;
  }

  &__name {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  &__price {
    padding-left: 10px;
  }

  .btn {
    border-radius: 0;
  }

  &__buttons {
    margin-top: 10px;
    display: flex;
    flex-direction: row;

    .btn {
      font-size: 12px !important;
      width: 100%;
    }
  }
}
</style>
